<template>
	<v-container fluid class="pb-0">
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat class="pb-0 pt-0">
					<v-card-text class="pa-2">
						<v-row class="d-flex justify-space-between">
							<v-col class="pb-0 pt-0">
								<v-card-title class="justify-left align-center pa-2">
									{{ $t('titles.bills') }}</v-card-title
								>
							</v-col>
							<v-col class="d-flex justify-end align-center pa-2 pb-0 pt-0" v-if="$route.params.id != 0">
								<v-btn color="basicButton" @click="addBill()">
									{{ $t('buttons.addBill') }}
									<v-icon small class="ml-2">fas fa-plus</v-icon>
								</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0">
								<v-simple-table fixed-header dense height="400px">
									<template v-slot:default>
										<thead>
											<tr>
												<th style="text-align: right">
													{{ $t('fields.billNumber') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.date') }}
												</th>
												<th style="text-align: right; white-space: nowrap">
													{{ $t('fields.amountBruto') }}
												</th>
												<th class="text-left" style="white-space: nowrap">
													{{ $t('fields.file') }}
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(item, key) in items"
												:key="key"
												:class="{ 'cursor-pointer': true }"
											>
												<td
													style="text-align: right; white-space: nowrap"
													@click="editBill(item.id)"
												>
													{{ item.bill_number }}
												</td>
												<td style="white-space: nowrap" @click="editBill(item.id)">
													{{
														item.date != null
															? item.date.split('-').reverse().join('.')
															: ''
													}}
												</td>
												<td
													style="text-align: right; white-space: nowrap"
													@click="editBill(item.id)"
												>
													{{
														item.total != null
															? Number.isInteger(item.total)
																? item.total.toLocaleString('hr') + ',00'
																: /^\d+\.\d{1}$/.test(item.total.toString())
																? item.total.toLocaleString('hr') + '0'
																: item.total.toLocaleString('hr')
															: ''
													}}
												</td>
												<td style="white-space: nowrap" @click="editBill(item.id)">
													<Upload
														:readonly="true"
														:showBorder="false"
														v-model="item.uploaded_file"
													></Upload>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<Modal :show-modal="showModal">
			<PaymentContractBill
				:billId="billId"
				:createInvoiceAfterSaving="createInvoiceAfterSaving"
				:redirectionRoute="redirectionRoute"
				@close="closeModal"
			></PaymentContractBill>
		</Modal>
	</v-container>
</template>

<script>
import Upload from '../../trinkets/Upload';
import Modal from '../../trinkets/Modal';
import PaymentContractBill from './PaymentContractBill';

export default {
	name: 'PaymentContractBills',
	components: { Modal, PaymentContractBill, Upload },
	props: {
		createInvoiceAfterSaving: {
			type: Boolean,
			default: false,
		},
		redirectionRoute: String,
	},
	data: function () {
		return {
			items: [],
			showModal: false,
			billId: 0,
		};
	},
	watch: {
		createInvoiceAfterSaving(newVal) {
			if (newVal) {
				this.addBill();
			}
		},
	},
	methods: {
		addBill() {
			this.showModal = true;
		},
		editBill(id) {
			this.billId = id;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
			this.billId = 0;
		},
		reloadData() {
			let vm = this;
			this.$APICall(
				'get',
				'payment-contract-bills/' + this.$route.params.id,
				null,
				(data, success) => {
					if (success) {
						vm.items = data.items;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
	},
	mounted() {
		let vm = this;
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$modalBus.$on('reloadPaymentContractBills', () => {
			vm.reloadData();
		});

		this.reloadData();

		if (this.createInvoiceAfterSaving) this.addBill();
	},
};
</script>

<style scoped></style>
